module.exports = {
    "collapse": `Ahenda`,
    "expand": `Laienda`
};


//# sourceMappingURL=et-EE.main.js.map
